var __bundle_addon_products = [];
var __product_ids_added = [];
var __bundle_products = [];
var __bundles_config = {
  minItems: 2,
  maxItems: 20,
  addon_default_close: false,
  addon_auto_open: true,
  addon_popup_manually: false,
};
$(document).ready(function(){
  if( window.screen.width < 1024 ){
    $("#video_mobile").attr("src",__video_mobile);
    $("#video_mobile").attr("type","video/mp4");
    //$("#video_mobile").play();
  }
  else{
    $("#video_desktop").attr("src",__video_dekstop);
    $("#video_desktop").attr("type","video/mp4");
    //$("#video_desktop").play();
  }
});

function addProductToBundleProductsForAdditionalProduct(handle,name){
  let tmp_product = getProduct(handle);
  addProductToBundleProducts(tmp_product,0,name,"",true);
  __bundle_addon_products.push(tmp_product["id"]);
}
  
function addProductToBundleProducts(product,variant_pointer,name,short_desc,is_hidden){
  if( product==null ) return;
  product["short_desc"] = short_desc;
  product["variant_pointer"] = variant_pointer;
  product["variant_id"] = product.variants[variant_pointer].id;
  if( name!=null ) product["name"] = name;
  product["is_hidden"] = is_hidden;
  if( variant_pointer==2 ) console.log(product);
  __bundle_products.push(product);
  __product_ids_added.push(product["id"]);
}

function getProduct(handle){
  for( let key in __products ){
    let current_handle = __products[key]["handle"];
    if( current_handle==handle ){
      return JSON.parse(JSON.stringify(__products[key]));
    }
  }
  return null;
}

function getVariantFromProduct(product,variant_id){
  for( let key in product["variants"] ){
    let variant = product["variants"][key];
    if( variant["id"]==variant_id ) return variant;
  }
  return null;
}

function getVariantImageSrc(images_info,image_id){
  for( let key in images_info ){
    let image_info = images_info[key];
    if( image_info["id"]==image_id ) return image_info["src"];
  }
  return null;
}

function getVariantFromProducts(products,variant_id){
  for(let key_product in products){
    let product = products[key_product];
    for( let key_variant in product["variants"] ){
      if( product["variants"][key_variant]["id"]==variant_id ) return product["variants"][key_variant];
    }
  }
  return null;
}

function getVariantFromProduct(product,variant_id){
  for( let key_variant in product["variants"] ){
    if( product["variants"][key_variant]["id"]==variant_id ) return product["variants"][key_variant];
  }
  return null;
}

function getProductFromProducts(products,variant_id){
  for(let key_product in products){
    let product = products[key_product];
    for( let key_variant in product["variants"] ){
      if( product["variants"][key_variant]["id"]==variant_id ) return product;
    }
  }
  return null;
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}